// extracted by mini-css-extract-plugin
module.exports = {"loaderCircular":"Loader_loaderCircular__4pDx0","spin":"Loader_spin___MJ04","loader_progress":"Loader_loader_progress__ZGsvI"};